"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = exposeChartingBackendToWindow;

var Highcharts = _interopRequireWildcard(require("highcharts"));

/* globals window */

/**
 * @deprecated until v8
 * @private
 * @returns {undefined}
 */
function exposeChartingBackendToWindow() {
  window.Highcharts = Highcharts;
}